import { render, staticRenderFns } from "./Items.vue?vue&type=template&id=4b8e4686&scoped=true"
import script from "./Items.vue?vue&type=script&lang=js"
export * from "./Items.vue?vue&type=script&lang=js"
import style0 from "./Items.vue?vue&type=style&index=0&id=4b8e4686&prod&lang=css&scoped=true"
import style1 from "./Items.vue?vue&type=style&index=1&id=4b8e4686&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8e4686",
  null
  
)

export default component.exports